
import { Options, Vue } from "vue-class-component";
import Section from "@/components/Section.vue";
import Init from "@/segments/Init.vue";
import Pool from "@/segments/Pool.vue";
import Gas from "@/segments/Gas.vue";
import DividedSection from "@/components/DividedSection.vue";
import Game from "@/segments/Game.vue";

@Options({
  components: {
    DividedSection,
    Game,
    Init,
    Pool,
    Gas,
    Section,
  },
})
export default class Main extends Vue {}
